import React from 'react';
import { useTheme } from '../../ThemeContext';


export default function OrganizationBasicInfo({
  name,
  setName,
  handle,
  setHandle,
  email,
  setEmail,
  website,
  setWebsite,
  location,
  setLocation,
  bio,
  setBio,
  handleAvailable,
  checkingHandle
}) {
  const { t, isDark } = useTheme();
  return (
    <>
      {/* Name - Required */}
      <div style={{ marginBottom: '20px' }}>
        <label style={{
          fontSize: '13px',
          fontWeight: '500',
          color: t.text,
          display: 'block',
          marginBottom: '6px',
          fontFamily: 'Poppins, sans-serif'
        }}>
          Organization Name *
        </label>
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Acme Corp"
          style={{
            width: '100%',
            padding: '12px',
            border: `1px solid ${t.borderStrong}`,
            borderRadius: '8px',
            fontSize: '14px',
            fontFamily: 'Poppins, sans-serif',
            backgroundColor: t.surface,
            outline: 'none'
          }}
          onFocus={(e) => e.target.style.borderColor = t.accent}
          onBlur={(e) => e.target.style.borderColor = t.borderStrong}
        />
      </div>

      {/* Handle - Required with availability check */}
      <div style={{ marginBottom: '20px' }}>
        <label style={{
          fontSize: '13px',
          fontWeight: '500',
          color: t.text,
          display: 'block',
          marginBottom: '6px',
          fontFamily: 'Poppins, sans-serif'
        }}>
          Handle * <span style={{ color: t.textSecondary, fontWeight: '400' }}>(@{handle || 'yourhandle'})</span>
        </label>
        <input
          type="text"
          value={handle}
          onChange={(e) => setHandle(e.target.value.toLowerCase().replace(/[^a-z0-9-]/g, ''))}
          placeholder="unique-handle"
          style={{
            width: '100%',
            padding: '12px',
            border: `1px solid ${handleAvailable === false ? t.error : handleAvailable === true ? t.success : t.borderStrong}`,
            borderRadius: '8px',
            fontSize: '14px',
            fontFamily: 'Poppins, sans-serif',
            backgroundColor: t.surface,
            outline: 'none'
          }}
          onFocus={(e) => {
            if (handleAvailable !== false && handleAvailable !== true) {
              e.target.style.borderColor = t.accent;
            }
          }}
          onBlur={(e) => {
            if (handleAvailable !== false && handleAvailable !== true) {
              e.target.style.borderColor = t.borderStrong;
            }
          }}
        />
        {checkingHandle && (
          <p style={{ fontSize: '12px', color: t.textSecondary, marginTop: '4px', fontFamily: 'Poppins, sans-serif' }}>
            Checking availability...
          </p>
        )}
        {!checkingHandle && handleAvailable === true && (
          <p style={{ fontSize: '12px', color: t.success, marginTop: '4px', fontFamily: 'Poppins, sans-serif' }}>
            ✓ Handle is available
          </p>
        )}
        {!checkingHandle && handleAvailable === false && (
          <p style={{ fontSize: '12px', color: t.error, marginTop: '4px', fontFamily: 'Poppins, sans-serif' }}>
            ✗ Handle is already taken
          </p>
        )}
      </div>

      {/* Email - Optional */}
      <div style={{ marginBottom: '20px' }}>
        <label style={{
          fontSize: '13px',
          fontWeight: '500',
          color: t.text,
          display: 'block',
          marginBottom: '6px',
          fontFamily: 'Poppins, sans-serif'
        }}>
          Email
        </label>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="contact@acmecorp.com"
          style={{
            width: '100%',
            padding: '12px',
            border: `1px solid ${t.borderStrong}`,
            borderRadius: '8px',
            fontSize: '14px',
            fontFamily: 'Poppins, sans-serif',
            backgroundColor: t.surface,
            outline: 'none'
          }}
          onFocus={(e) => e.target.style.borderColor = t.accent}
          onBlur={(e) => e.target.style.borderColor = t.borderStrong}
        />
      </div>

      {/* Website - Optional */}
      <div style={{ marginBottom: '20px' }}>
        <label style={{
          fontSize: '13px',
          fontWeight: '500',
          color: t.text,
          display: 'block',
          marginBottom: '6px',
          fontFamily: 'Poppins, sans-serif'
        }}>
          Website
        </label>
        <input
          type="url"
          value={website}
          onChange={(e) => setWebsite(e.target.value)}
          placeholder="https://acmecorp.com"
          style={{
            width: '100%',
            padding: '12px',
            border: `1px solid ${t.borderStrong}`,
            borderRadius: '8px',
            fontSize: '14px',
            fontFamily: 'Poppins, sans-serif',
            backgroundColor: t.surface,
            outline: 'none'
          }}
          onFocus={(e) => e.target.style.borderColor = t.accent}
          onBlur={(e) => e.target.style.borderColor = t.borderStrong}
        />
      </div>

      {/* Location - Optional */}
      <div style={{ marginBottom: '20px' }}>
        <label style={{
          fontSize: '13px',
          fontWeight: '500',
          color: t.text,
          display: 'block',
          marginBottom: '6px',
          fontFamily: 'Poppins, sans-serif'
        }}>
          Location
        </label>
        <input
          type="text"
          value={location}
          onChange={(e) => setLocation(e.target.value)}
          placeholder="San Francisco, CA"
          style={{
            width: '100%',
            padding: '12px',
            border: `1px solid ${t.borderStrong}`,
            borderRadius: '8px',
            fontSize: '14px',
            fontFamily: 'Poppins, sans-serif',
            backgroundColor: t.surface,
            outline: 'none'
          }}
          onFocus={(e) => e.target.style.borderColor = t.accent}
          onBlur={(e) => e.target.style.borderColor = t.borderStrong}
        />
      </div>

      {/* Bio - Optional with character limit */}
      <div style={{ marginBottom: '32px' }}>
        <label style={{
          fontSize: '13px',
          fontWeight: '500',
          color: t.text,
          display: 'block',
          marginBottom: '6px',
          fontFamily: 'Poppins, sans-serif'
        }}>
          Bio <span style={{ color: t.textSecondary, fontWeight: '400' }}>({bio.length}/200)</span>
        </label>
        <textarea
          value={bio}
          onChange={(e) => setBio(e.target.value)}
          placeholder="Brief description..."
          rows={3}
          maxLength={200}
          style={{
            width: '100%',
            padding: '12px',
            border: `1px solid ${t.borderStrong}`,
            borderRadius: '8px',
            fontSize: '14px',
            fontFamily: 'Poppins, sans-serif',
            backgroundColor: t.surface,
            outline: 'none',
            resize: 'vertical'
          }}
          onFocus={(e) => e.target.style.borderColor = t.accent}
          onBlur={(e) => e.target.style.borderColor = t.borderStrong}
        />
      </div>
    </>
  );
}
